import {
  Box,
  Card,
  CardBody,
  Flex,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { useState } from "react";

export const ShowChildrenOnHoverCard = ({
  children,
  cover,
}: {
  children?: React.ReactNode;
  cover: React.ReactNode;
}) => {
  const [shown, setIsShown] = useState(false);

  return (
    <CustomCard
      onMouseEnter={() => setIsShown(true)}
      onMouseLeave={() => setIsShown(false)}
    >
      {!shown && <CardBody>{cover}</CardBody>}
      {shown && <CardBody>{children}</CardBody>}
    </CustomCard>
  );
};

export const CardCover = ({ icon, alt, title }) => (
  <Flex
    direction="row"
    gap={3}
    justifyContent="center"
    alignItems="center"
    className="text-primary"
    fontSize="1em"
  >
    {icon}
    <Text color={useColorModeValue("", "neutral.10")} align="center">
      {title}
    </Text>
  </Flex>
);

export const CustomCard = ({ children, ...props }: any) => {
  return (
    <Card
      minH="76px"
      minW="200px"
      background={useColorModeValue("white", "rgba(255,255,255,0.1)")}
      shadow="base"
      cursor="pointer"
      justifyContent="center"
      {...props}
    >
      <Box display="flex" justifyContent="center">
        {children}
      </Box>
    </Card>
  );
};
